
export function generatePdf(url) {
  // 判断是否是移动端（可自行优化设备检测）
  const isMobile = (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent));
// 统一跳转方法（兼容PC/移动端）
    // 尝试用动态 <a> 标签跳转（最佳兼容性）
    const link = document.createElement('a');
    link.href = url;
    link.target = '_blank';
    link.rel = 'noopener noreferrer'; // 安全优化
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    // 移动端额外处理：如果跳转失败（如被拦截），降级为当前页跳转
    if (isMobile) {
      setTimeout(() => {
        if (!window.closed && !document.hidden) {
          window.location.href = url; // 降级方案
        }
      }, 500);
    }
}

export function  copyTextToClipboard(text) {
  // 创建一个临时 input 元素
  const input = document.createElement('input');
  input.setAttribute('readonly', 'readonly');
  input.value = text;
  document.body.appendChild(input);
  input.select();
  const success = document.execCommand('copy');
  document.body.removeChild(input);

  if (success) {
    console.log('复制成功');
  } else {
    console.warn('复制失败');
  }
}
